import { Divider, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Image, Inline, Stack, useResponsiveValue } from '@superdispatch/ui';
import { Box, Button, TextBox } from '@superdispatch/ui-lab';
import { openExternalURL } from 'shared/helpers/URLHelpers';
import styled from 'styled-components';
import { useLoadSuggestions } from '../load-suggestions/data/LoadSuggestionsAPI';
import { ExploreSuggestedLoads } from './ExploreSuggestedLoads';
import emptyLoadOfferImageDark from './assets/empty-load-dark.png';
import emptyLoadOfferImage from './assets/empty-load.png';
import { viewportHeight } from 'shared/layout/NavigationHeaderBannerHeight';

const StyledDivider = styled(Divider)`
  width: 102px;
`;

function LoadOffersFallbackEmptyState() {
  const isMobile = useResponsiveValue(true, false);

  return (
    <Box
      height={[viewportHeight('128px'), '100%']}
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Stack space="medium" align="center">
        <Image
          width="68px"
          height="80px"
          src={emptyLoadOfferImage}
          alt="No Load Offers"
          srcDark={emptyLoadOfferImageDark}
        />
        <Stack space="xsmall" align="center">
          <Typography color="textSecondary" align="center" variant="h3">
            No Offers Yet
          </Typography>
          <Box width="320px">
            <Typography align="center" color="textSecondary">
              To receive offers, start by booking a load. Once the shipper
              approves your booking, offers will appear here.
            </Typography>
          </Box>
        </Stack>
        <Button
          onClick={() => {
            openExternalURL('/loadboard');
          }}
          variant="primary"
          size={isMobile ? 'medium' : 'large'}
        >
          Find Loads on Super Loadboard
        </Button>
      </Stack>
    </Box>
  );
}

function LoadOffersEmptyStateWithSuggestedLoads() {
  return (
    <Box
      height="600px"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Stack space="large" align="center">
        <Stack space="xsmall" align="center">
          <TextBox variant="heading-4" color="secondary">
            No Offers Yet
          </TextBox>
          <Box width="320px">
            <TextBox color="secondary" align="center">
              To receive offers, start by booking a load. Once the shipper
              approves your booking, offers will appear here.
            </TextBox>
          </Box>
        </Stack>
        <Inline verticalAlign="center">
          <StyledDivider />
          <TextBox color="secondary">or</TextBox>
          <StyledDivider />
        </Inline>
        <ExploreSuggestedLoads source="Load Offers Drawer" />
      </Stack>
    </Box>
  );
}

export function LoadOffersEmptyState() {
  const { data = [], isLoading } = useLoadSuggestions([]);
  const unseenSuggestedLoads = data.filter((load) => !load.is_seen);
  const shouldShowSuggestedLoadsNudging = unseenSuggestedLoads.length > 3;

  if (isLoading) {
    return (
      <Stack>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Stack>
    );
  }

  if (shouldShowSuggestedLoadsNudging) {
    return <LoadOffersEmptyStateWithSuggestedLoads />;
  }

  return <LoadOffersFallbackEmptyState />;
}
